import script from "./PerfilCombobox.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilCombobox.vue?vue&type=script&setup=true&lang=js"

import "./PerfilCombobox.vue?vue&type=style&index=0&id=6e0359a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e0359a2"]])

export default __exports__